import LogoutModalContainer from './container';

export default LogoutModalContainer;
